//
// string-utils.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/*jshint devel: true, jquery: true */
/*global angular: false, moment: true, window: false, _: false */

(function() {
    "use strict";

    angular.module('curalate').factory('StringUtils', function() {
        // This regex needs to be so long because it parses emojis as part of hashtags
        // It was adapted from the Python emojineering regex here: http://instagram-engineering.tumblr.com/post/118304328152/emojineering-part-2-implementing-hashtag-emoji
        // Only three changes:
        //  Change 1: Wrapping the non-hashtag part in a capturing group to capture the whole hashtag
        //  Change 2: Removing the starting (?<!&), a Python regex lookbehind that doesn't have any JS equivalent
        //  Change 3: Adding [\u00A0-\u201C\u201E-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF] to match characters from non-latin alphabets (ie: Cyrillic, Arabic, etc.), diacritics,
        //            etc. But excluding right quotatation to support clients quoting hashtags. i.e. Respond with “#agree”
        //
        var hashtagRegex = /(?:#)((?:\w|[\u00A0-\u201C\u201E-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|(?:0\u20E3|1\u20E3|2\u20E3|3\u20E3|4\u20E3|5\u20E3|6\u20E3|7\u20E3|8\u20E3|9\u20E3|#\u20E3|\\*\u20E3|\uD83C(?:\uDDE6\uD83C(?:\uDDEB|\uDDFD|\uDDF1|\uDDF8|\uDDE9|\uDDF4|\uDDEE|\uDDF6|\uDDEC|\uDDF7|\uDDF2|\uDDFC|\uDDE8|\uDDFA|\uDDF9|\uDDFF|\uDDEA)|\uDDE7\uD83C(?:\uDDF8|\uDDED|\uDDE9|\uDDE7|\uDDFE|\uDDEA|\uDDFF|\uDDEF|\uDDF2|\uDDF9|\uDDF4|\uDDE6|\uDDFC|\uDDFB|\uDDF7|\uDDF3|\uDDEC|\uDDEB|\uDDEE|\uDDF6|\uDDF1)|\uDDE8\uD83C(?:\uDDF2|\uDDE6|\uDDFB|\uDDEB|\uDDF1|\uDDF3|\uDDFD|\uDDF5|\uDDE8|\uDDF4|\uDDEC|\uDDE9|\uDDF0|\uDDF7|\uDDEE|\uDDFA|\uDDFC|\uDDFE|\uDDFF|\uDDED)|\uDDE9\uD83C(?:\uDDFF|\uDDF0|\uDDEC|\uDDEF|\uDDF2|\uDDF4|\uDDEA)|\uDDEA\uD83C(?:\uDDE6|\uDDE8|\uDDEC|\uDDF7|\uDDEA|\uDDF9|\uDDFA|\uDDF8|\uDDED)|\uDDEB\uD83C(?:\uDDF0|\uDDF4|\uDDEF|\uDDEE|\uDDF7|\uDDF2)|\uDDEC\uD83C(?:\uDDF6|\uDDEB|\uDDE6|\uDDF2|\uDDEA|\uDDED|\uDDEE|\uDDF7|\uDDF1|\uDDE9|\uDDF5|\uDDFA|\uDDF9|\uDDEC|\uDDF3|\uDDFC|\uDDFE|\uDDF8|\uDDE7)|\uDDED\uD83C(?:\uDDF7|\uDDF9|\uDDF2|\uDDF3|\uDDF0|\uDDFA)|\uDDEE\uD83C(?:\uDDF4|\uDDE8|\uDDF8|\uDDF3|\uDDE9|\uDDF7|\uDDF6|\uDDEA|\uDDF2|\uDDF1|\uDDF9)|\uDDEF\uD83C(?:\uDDF2|\uDDF5|\uDDEA|\uDDF4)|\uDDF0\uD83C(?:\uDDED|\uDDFE|\uDDF2|\uDDFF|\uDDEA|\uDDEE|\uDDFC|\uDDEC|\uDDF5|\uDDF7|\uDDF3)|\uDDF1\uD83C(?:\uDDE6|\uDDFB|\uDDE7|\uDDF8|\uDDF7|\uDDFE|\uDDEE|\uDDF9|\uDDFA|\uDDF0|\uDDE8)|\uDDF2\uD83C(?:\uDDF4|\uDDF0|\uDDEC|\uDDFC|\uDDFE|\uDDFB|\uDDF1|\uDDF9|\uDDED|\uDDF6|\uDDF7|\uDDFA|\uDDFD|\uDDE9|\uDDE8|\uDDF3|\uDDEA|\uDDF8|\uDDE6|\uDDFF|\uDDF2|\uDDF5|\uDDEB)|\uDDF3\uD83C(?:\uDDE6|\uDDF7|\uDDF5|\uDDF1|\uDDE8|\uDDFF|\uDDEE|\uDDEA|\uDDEC|\uDDFA|\uDDEB|\uDDF4)|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C(?:\uDDEB|\uDDF0|\uDDFC|\uDDF8|\uDDE6|\uDDEC|\uDDFE|\uDDEA|\uDDED|\uDDF3|\uDDF1|\uDDF9|\uDDF7|\uDDF2)|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C(?:\uDDEA|\uDDF4|\uDDFA|\uDDFC|\uDDF8)|\uDDF8\uD83C(?:\uDDFB|\uDDF2|\uDDF9|\uDDE6|\uDDF3|\uDDE8|\uDDF1|\uDDEC|\uDDFD|\uDDF0|\uDDEE|\uDDE7|\uDDF4|\uDDF8|\uDDED|\uDDE9|\uDDF7|\uDDEF|\uDDFF|\uDDEA|\uDDFE)|\uDDF9\uD83C(?:\uDDE9|\uDDEB|\uDDFC|\uDDEF|\uDDFF|\uDDED|\uDDF1|\uDDEC|\uDDF0|\uDDF4|\uDDF9|\uDDE6|\uDDF3|\uDDF7|\uDDF2|\uDDE8|\uDDFB)|\uDDFA\uD83C(?:\uDDEC|\uDDE6|\uDDF8|\uDDFE|\uDDF2|\uDDFF)|\uDDFB\uD83C(?:\uDDEC|\uDDE8|\uDDEE|\uDDFA|\uDDE6|\uDDEA|\uDDF3)|\uDDFC\uD83C(?:\uDDF8|\uDDEB)|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C(?:\uDDF9|\uDDEA)|\uDDFF\uD83C(?:\uDDE6|\uDDF2|\uDDFC))))[\ufe00-\ufe0f\u200d]?)+)/g;
        var mentionRegex = /(@[A-Za-z0-9_\-\.]+[A-Za-z0-9_])/g;
        // For Instagram, only match if the @mention is at the start of the text or preceded by whitespace.
        var igMentionRegex = /(?:^|\s)(@[A-Za-z0-9_\-\.]+[A-Za-z0-9_])/g;
        // Mega regex that matches either an Instagram mention or hashtag. It was adapted from `hashtagRegex` and `igMentionRegex` above, except it also
        // captures the '#' character preceding a hashtag so we can check the first character of the captured value to easily determine whether it's a
        // mention or hashtag.
        var igMentionOrHashtagRegex = /(?:^|\s)(@[A-Za-z0-9_\-\.]+[A-Za-z0-9_])|(#(?:\w|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|(?:0\u20E3|1\u20E3|2\u20E3|3\u20E3|4\u20E3|5\u20E3|6\u20E3|7\u20E3|8\u20E3|9\u20E3|#\u20E3|\\*\u20E3|\uD83C(?:\uDDE6\uD83C(?:\uDDEB|\uDDFD|\uDDF1|\uDDF8|\uDDE9|\uDDF4|\uDDEE|\uDDF6|\uDDEC|\uDDF7|\uDDF2|\uDDFC|\uDDE8|\uDDFA|\uDDF9|\uDDFF|\uDDEA)|\uDDE7\uD83C(?:\uDDF8|\uDDED|\uDDE9|\uDDE7|\uDDFE|\uDDEA|\uDDFF|\uDDEF|\uDDF2|\uDDF9|\uDDF4|\uDDE6|\uDDFC|\uDDFB|\uDDF7|\uDDF3|\uDDEC|\uDDEB|\uDDEE|\uDDF6|\uDDF1)|\uDDE8\uD83C(?:\uDDF2|\uDDE6|\uDDFB|\uDDEB|\uDDF1|\uDDF3|\uDDFD|\uDDF5|\uDDE8|\uDDF4|\uDDEC|\uDDE9|\uDDF0|\uDDF7|\uDDEE|\uDDFA|\uDDFC|\uDDFE|\uDDFF|\uDDED)|\uDDE9\uD83C(?:\uDDFF|\uDDF0|\uDDEC|\uDDEF|\uDDF2|\uDDF4|\uDDEA)|\uDDEA\uD83C(?:\uDDE6|\uDDE8|\uDDEC|\uDDF7|\uDDEA|\uDDF9|\uDDFA|\uDDF8|\uDDED)|\uDDEB\uD83C(?:\uDDF0|\uDDF4|\uDDEF|\uDDEE|\uDDF7|\uDDF2)|\uDDEC\uD83C(?:\uDDF6|\uDDEB|\uDDE6|\uDDF2|\uDDEA|\uDDED|\uDDEE|\uDDF7|\uDDF1|\uDDE9|\uDDF5|\uDDFA|\uDDF9|\uDDEC|\uDDF3|\uDDFC|\uDDFE|\uDDF8|\uDDE7)|\uDDED\uD83C(?:\uDDF7|\uDDF9|\uDDF2|\uDDF3|\uDDF0|\uDDFA)|\uDDEE\uD83C(?:\uDDF4|\uDDE8|\uDDF8|\uDDF3|\uDDE9|\uDDF7|\uDDF6|\uDDEA|\uDDF2|\uDDF1|\uDDF9)|\uDDEF\uD83C(?:\uDDF2|\uDDF5|\uDDEA|\uDDF4)|\uDDF0\uD83C(?:\uDDED|\uDDFE|\uDDF2|\uDDFF|\uDDEA|\uDDEE|\uDDFC|\uDDEC|\uDDF5|\uDDF7|\uDDF3)|\uDDF1\uD83C(?:\uDDE6|\uDDFB|\uDDE7|\uDDF8|\uDDF7|\uDDFE|\uDDEE|\uDDF9|\uDDFA|\uDDF0|\uDDE8)|\uDDF2\uD83C(?:\uDDF4|\uDDF0|\uDDEC|\uDDFC|\uDDFE|\uDDFB|\uDDF1|\uDDF9|\uDDED|\uDDF6|\uDDF7|\uDDFA|\uDDFD|\uDDE9|\uDDE8|\uDDF3|\uDDEA|\uDDF8|\uDDE6|\uDDFF|\uDDF2|\uDDF5|\uDDEB)|\uDDF3\uD83C(?:\uDDE6|\uDDF7|\uDDF5|\uDDF1|\uDDE8|\uDDFF|\uDDEE|\uDDEA|\uDDEC|\uDDFA|\uDDEB|\uDDF4)|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C(?:\uDDEB|\uDDF0|\uDDFC|\uDDF8|\uDDE6|\uDDEC|\uDDFE|\uDDEA|\uDDED|\uDDF3|\uDDF1|\uDDF9|\uDDF7|\uDDF2)|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C(?:\uDDEA|\uDDF4|\uDDFA|\uDDFC|\uDDF8)|\uDDF8\uD83C(?:\uDDFB|\uDDF2|\uDDF9|\uDDE6|\uDDF3|\uDDE8|\uDDF1|\uDDEC|\uDDFD|\uDDF0|\uDDEE|\uDDE7|\uDDF4|\uDDF8|\uDDED|\uDDE9|\uDDF7|\uDDEF|\uDDFF|\uDDEA|\uDDFE)|\uDDF9\uD83C(?:\uDDE9|\uDDEB|\uDDFC|\uDDEF|\uDDFF|\uDDED|\uDDF1|\uDDEC|\uDDF0|\uDDF4|\uDDF9|\uDDE6|\uDDF3|\uDDF7|\uDDF2|\uDDE8|\uDDFB)|\uDDFA\uD83C(?:\uDDEC|\uDDE6|\uDDF8|\uDDFE|\uDDF2|\uDDFF)|\uDDFB\uD83C(?:\uDDEC|\uDDE8|\uDDEE|\uDDFA|\uDDE6|\uDDEA|\uDDF3)|\uDDFC\uD83C(?:\uDDF8|\uDDEB)|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C(?:\uDDF9|\uDDEA)|\uDDFF\uD83C(?:\uDDE6|\uDDF2|\uDDFC))))[\ufe00-\ufe0f\u200d]?)+)/g;

        /**
         * Generates a filename given an object containing name components
         * Required keys:
         *   * base -- the base filename
         *   * extension -- the file's extension
         * @param attributes
         * @returns {string}
         */
        var generateFileName = function(attributes) {
            var base = attributes.base.trim().replace(/\s+/g, '-'), // Sanitize base filename by trimming and replacing remaining whitespace with dashes
                remainingKeys = _(attributes).omit('base', 'extension', 'dateRange'),
                parts = [base],
                onlyAlls,
                dateRangeString;

            if (attributes.dateRange) {
                if (!attributes.dateRange.from && !attributes.dateRange.to) {
                    parts.push('all-time');
                } else {
                    // Assumes that both properties exist!
                    dateRangeString = [attributes.dateRange.from.replace(/\//g, '-'), attributes.dateRange.to.replace(/\//g, '-')].join('_');
                    parts = parts.concat(dateRangeString);
                }
            }

            onlyAlls = _.chain(attributes).pairs().filter(function(pair) { return pair[1] === 'all'; }).object().value();

            if (_(onlyAlls).keys().length > 1) {
                parts.push('all');
                remainingKeys = _(attributes).omit.apply(this, _(onlyAlls).keys());
            }

            _(remainingKeys).each(function(value) { parts.push(value); });

            return parts.join('-') + '.' + attributes.extension;
        };

        /**
         * Formats a list of strings as a grammatically correct string
         *
         * @param list The list of strings to format
         * @returns {string} One string with every element of the list separated by commas
         */
        var toGrammaticallyCorrectList = function(list) {
            var lastElement;

            if (!list || !_.isArray(list)) {
                return "";
            }

            switch (list.length) {
                case 0:
                    return "";
                case 1:
                    return list[0];
                case 2:
                    return list[0] + " and " + list[1];
                default:
                    lastElement = list.slice(-1).pop();
                    return list.slice(0, -1).join(", ") + ", and " + lastElement;
            }
        };

        var formatString = function format(str) {
            var counter = 0, formatArr = Array.prototype.slice.call(arguments, 1);
            return str.replace(/%s/g, function() {
                return formatArr[counter++];
            });
        };

        /**
         * Executes a regex on a string repeatedly to find all matches.
         * @param regex      RegExp to execute on the string
         * @param haystack   String to search for matches within
         * @returns {Array}  Array of all matches of the regex on the haystack
         */
        var findAllMatches = function(regex, haystack) {
            var match;
            var matches = [];
            while (match = regex.exec(haystack)) {
                matches.push(match);
            }
            return matches;
        };

        /**
         * Parses out at-mentions included in the specified string.
         * @param   str             The string to parse at-mentions from.
         * @param   socialNetwork   Optional social network name
         * @return  {Array}         An array of at-mentions present in the specified string.
         */
        var extractMentions = function(str, socialNetwork) {
            if (socialNetwork && socialNetwork.toLowerCase() === 'instagram') {
                return _.toArray(_.map(str.match(igMentionRegex), function(s) { return s.trim(); }));
            }
            return str.match(mentionRegex);
        };

        /**
         * Replaces all at-mention occurrences in a string with a given callback function.
         * @param   str                     The string to replace at-mentions from.
         * @param   cb {function(string)}   A callback that provides the replacement for a match.
         * @param   socialNetwork           Optional social network name
         * @returns {string} The specified string with all at-mentions replaced by the callback function.
         */
        var replaceMentions = function(str, cb, socialNetwork) {
            if (socialNetwork && socialNetwork.toLowerCase() === 'instagram') {
                return str.replace(igMentionRegex, cb);
            }
            return str.replace(mentionRegex, cb);
        };

        /**
         * Parses out hashtags included in the specified string.
         * @param   str         The string to parse hashtags from.
         * @return  {Array}     An array of hashtags present in the specified string.
         */
        var extractHashtags = function(str) {
            return str.match(hashtagRegex);
        };

        /**
         * Replaces all hashtag occurrences in a string with a given callback function.
         * @param   str         The string to replace hashtags from.
         * @param   cb          {function(string)} A callback that provides the replacement for a match.
         * @returns {string}    The specified string with all hashtags replaced by the callback function.
         */
        var replaceHashtags = function(str, cb) {
            return str.replace(hashtagRegex, cb);
        };

        /**
         * Takes text as input and parses it to return a representation as an array of typed objects. For example, the input 'Hello @curalate! #shippy' would
         * result in output:
         *   [{ type: 'text', value: 'Hello '}, { type: 'mention', value: '@curalate'}, { type: 'text', value: '! '}, { type: 'hashtag', value: '#shippy'}]
         * @param   text    The string to parse.
         * @returns {Array} The parsed array of objects with properties { type, value }, where type is one of ('hashtag', 'mention',' text').
         */
        var parseSocialText = function(text) {
            igMentionOrHashtagRegex.lastIndex = 0;
            var generateSegmentObj = function(type, value) {
                return {
                    type: type,
                    value: value
                }
            };

            var nextMatch = function(remainingLength) {
                var match = igMentionOrHashtagRegex.exec(text);

                if (match) {
                    var fullMatch = match[0];

                    // Grab either a mention or a hashtag capture
                    var valueCapture = match[1] || match[2];
                    var matchOffset = (fullMatch.length - valueCapture.length);
                    var textOffset = (text.length - remainingLength);

                    return {
                        index: match.index + matchOffset - textOffset,
                        value: valueCapture,
                        hashtagOrMention: (valueCapture[0] === '#' ? 'hashtag' : 'mention')
                    };
                }

                return null;
            };

            var remainingText = text;
            var result = [];

            while (remainingText.length > 0) {
                var match = nextMatch(remainingText.length);

                if (!match) {
                    // No match, so extract the rest of the string as text.
                    var remainingTextSegmentObj = generateSegmentObj('text', remainingText);
                    result.push(remainingTextSegmentObj);
                    remainingText = remainingText.slice(remainingText.length);

                    break;
                }

                if (match.index > 0) {
                    // Text precedes our match, so extract it.
                    var precedingText = remainingText.slice(0, match.index);
                    var precedingTextSegmentObj = generateSegmentObj('text', precedingText);
                    result.push(precedingTextSegmentObj);
                }

                var hashtagOrMentionSegmentObj = generateSegmentObj(match.hashtagOrMention, match.value);
                result.push(hashtagOrMentionSegmentObj);

                remainingText = remainingText.slice(match.index + match.value.length);
            }

            return result;
        };

        return {
            parseSocialText: parseSocialText,
            generateFileName: generateFileName,
            formatString: formatString,
            findAllMatches: findAllMatches,
            extractHashtags: extractHashtags,
            extractMentions: extractMentions,
            toGrammaticallyCorrectList: toGrammaticallyCorrectList,
            replaceHashtags: replaceHashtags,
            replaceMentions: replaceMentions
        };
    });
})();
